<template>
  <aside
    class="absolute top-50 bg-dark-gray br2 left-2 z-9999 pa4 shadow-5"
    style="max-width: 24rem; transform: translateY(-50%)"
  >
    <div class="relative mt2 white f3 mb3 pb2 fw6 lh-title">
      Find Your Home
    </div>
    <FilterDropdown
      :icon="icon.region"
      :items="developmentsList"
      title="Regions"
      @select="selectMarker"
      @set-filter="setRegion"
    />
    <FilterDropdown
      :icon="icon.availability"
      :items="availability"
      title="Availability"
      @set-filter="setAvailability"
    />
    <FilterDropdown
      :icon="icon.bedrooms"
      :items="bedrooms"
      title="Bedrooms"
      @set-filter="setBedrooms"
    />
    <FilterDropdown
      :icon="icon.purchase"
      :items="purchase"
      title="Purchase Type"
      @set-filter="setPurchaseType"
    />
    <FilterDropdown
      :icon="icon.price"
      :items="price.display"
      title="Price"
      @set-filter="setPrice"
    />
    <FilterDropdown
      :icon="icon.style"
      :items="style"
      title="House Style"
      @set-filter="setHouseStyle"
    />
    <FilterDropdown
      :icon="icon.type"
      :items="type"
      title="House Type"
      @set-filter="setHouseType"
    />
    <div
      v-if="showCriteria"
      class="relative"
    >
      <div class="flex items-center justify-between">
        <div class="pv4 white f3 fw6 lh-title">
          Your Criteria
        </div>
        <div class="flex">
          <div
            class="border br4 ba pv1 pr1 pl2 white"
            @click="clearAllFilters()"
          >
            Clear Filters
            <svg
              class="pl2"
              style="padding-right: 0.35rem; transform: scale(1.5)"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 5C0 2.235 2.235 0 5 0C7.765 0 10 2.235 10 5C10 7.765 7.765 10 5 10C2.235 10 0 7.765 0 5ZM5 4.295L6.295 3L7 3.705L5.705 5L7 6.295L6.295 7L5 5.705L3.705 7L3 6.295L4.295 5L3 3.705L3.705 3L5 4.295Z"
                style="fill: #FFFFFF;"
              />
            </svg>
          </div>
        </div>
      </div>
      <Pill
        v-show="activeFilters.region"
        class="mb2 b--black bg-white dark-gray"
        :info="activeFilters.region"
        :close="true"
        @click="$store.commit('setRegion', null)"
      />
      <Pill
        v-show="activeFilters.availability"
        class="mb2 b--black bg-white dark-gray"
        :info="activeFilters.availability"
        :close="true"
        @click="$store.commit('setFilterAvailability', null)"
      />
      <Pill
        v-show="activeFilters.bedrooms"
        class="mb2 b--black bg-white dark-gray"
        :info="activeFilters.bedrooms + ' bedrooms'"
        :close="true"
        @click="$store.commit('setFilterBedrooms', null)"
      />
      <Pill
        v-show="activeFilters.price.display"
        class="mb2 b--black bg-white dark-gray"
        :info="activeFilters.price.display"
        :close="true"
        @click="clearPrice()"
      />
      <Pill
        v-show="activeFilters.purchaseType"
        class="mb2 b--black bg-white dark-gray"
        :info="activeFilters.purchaseType"
        :close="true"
        @click="$store.commit('setFilterPurchaseType', null)"
      />
      <Pill
        v-show="activeFilters.style"
        class="mb2 b--black bg-white dark-gray"
        :info="activeFilters.style"
        :close="true"
        @click="$store.commit('setFilterStyle', null)"
      />
      <Pill
        v-show="activeFilters.type"
        class="mb2 b--black bg-white dark-gray"
        :info="activeFilters.type"
        :close="true"
        @click="$store.commit('setFilterType', null)"
      />
    </div>
  </aside>
</template>

<script>
import FilterDropdown from '@/components/FilterDropdown.vue'
import Pill from '@/components/Pill'

const uniq = require('lodash/uniq')
const findIndex = require('lodash/findIndex')
const sortBy = require('lodash/sortBy')

export default {
  name: 'Filters',
  components: {
    FilterDropdown,
    Pill
  },
  props: {
    getPlots: {
      type: Array,
      default: null
    },
    developments: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      icon: {
        availability: require('@/assets/img/filter-availability.svg'),
        bedrooms: require('@/assets/img/filter-bedrooms.svg'),
        check: require('@/assets/img/check-circle.svg'),
        circle: require('@/assets/img/circle.svg'),
        fullCircle: require('@/assets/img/icon-checkbox-solid.svg'),
        price: require('@/assets/img/filter-price.svg'),
        purchase: require('@/assets/img/filter-purchase.svg'),
        style: require('@/assets/img/filter-style.svg'),
        type: require('@/assets/img/filter-type.svg'),
        region: require('@/assets/img/filter-region.svg')
      }
    }
  },
  computed: {
    developmentsList () {
      const selectOptions = sortBy(this.developments.slice(0), function (o) {
        return o.location.area
      })
      const areas = [
        {
          title: 'Cheshire',
          location: {
            lat: 53.2127172,
            lng: -3.111936
          },
          area: true
        },
        {
          title: 'Greater-Manchester',
          location: {
            lat: 53.4591252,
            lng: -2.5895857
          },
          area: true
        },
        {
          title: 'Lancashire',
          location: {
            lat: 53.8612403,
            lng: -2.844979
          },
          area: true
        }
      ]

      for (let i = 0; i < areas.length; i++) {
        const element = areas[i]
        const target = findIndex(selectOptions, function (o) {
          return o.location.area === element.title
        })
        selectOptions.splice(target, 0, element)
      }

      return selectOptions
    },
    activeFilters () {
      return this.$store.state.siteplan.filters
    },
    showCriteria () {
      if (this.activeFilters.availability || this.activeFilters.region || this.activeFilters.bedrooms || this.activeFilters.price.max || this.activeFilters.purchaseType || this.activeFilters.style || this.activeFilters.type) {
        return true
      } else {
        return false
      }
    },
    availability () {
      const availability = []
      this.getPlots.forEach(plots => {
        if (plots) {
          plots.forEach(plot => {
            if (plot.statusCode) {
              availability.push(plot.statusCode)
            }
          })
        }
      })
      return uniq(availability.sort())
    },
    bedrooms () {
      const bedrooms = []
      this.getPlots.forEach(plots => {
        if (plots) {
          plots.forEach(plot => {
            if (plot.bedroomsCount) {
              bedrooms.push(plot.bedroomsCount)
            }
          })
        }
      })
      return uniq(bedrooms.sort())
    },
    purchase () {
      const purchase = []
      this.getPlots.forEach(plots => {
        if (plots) {
          plots.forEach(plot => {
            if (plot.sellingType) {
              purchase.push(plot.sellingType)
            }
          })
        }
      })
      return uniq(purchase.sort())
    },
    price () {
      let price = []
      this.getPlots.forEach(plots => {
        if (plots) {
          plots.forEach(plot => {
            if (plot.price) {
              price.push(plot.price)
            }
          })
        }
      })
      price = uniq(price.sort())

      let priceRounded = []
      priceRounded.push(Math.floor(price[0] / 100000) * 100)
      price.forEach(element => {
        priceRounded.push(Math.round(element / 100000) * 100)
      })
      priceRounded = uniq(priceRounded)

      const priceRange = {
        display: [],
        store: []
      }
      for (let i = 0; i < priceRounded.length - 1; i++) {
        priceRange.display.push('&pound; ' + priceRounded[i] + 'k to &pound; ' + priceRounded[i + 1] + 'k')
        const storeItem = {
          min: priceRounded[i],
          max: priceRounded[i + 1]
        }
        priceRange.store.push(storeItem)
      }
      return priceRange
    },
    style () {
      const style = []
      this.getPlots.forEach(plots => {
        if (plots) {
          plots.forEach(plot => {
            if (plot.houseType) {
              style.push(plot.houseType)
            }
          })
        }
      })
      return uniq(style.sort())
    },
    type () {
      const type = []
      this.getPlots.forEach(plots => {
        if (plots) {
          plots.forEach(plot => {
            if (plot.unitType) {
              type.push(plot.unitType)
            }
          })
        }
      })
      return uniq(type.sort())
    }
  },
  methods: {
    clearAllFilters () {
      this.$store.commit('clearFiltersSiteplan')
    },
    selectMarker (marker) {
      this.$emit('select', marker)
    },
    clearPrice () {
      const payload = {
        display: null,
        min: null,
        max: null
      }
      this.$store.commit('setFilterPrice', payload)
    },
    setAvailability (payload) {
      this.$store.commit('setFilterAvailability', payload)
    },
    setRegion (payload) {
      this.$store.commit('setRegion', payload)
    },
    setBedrooms (payload) {
      this.$store.commit('setFilterBedrooms', payload)
    },
    setPurchaseType (payload) {
      this.$store.commit('setFilterPurchaseType', payload)
    },
    setPrice (payload) {
      let price = {
        display: payload,
        max: null,
        min: null
      }
      for (let i = 0; i < this.price.display.length; i++) {
        const element = this.price.display[i]
        if (element === payload) {
          price.max = this.price.store[i].max
          price.min = this.price.store[i].min
        }
      }
      this.$store.commit('setFilterPrice', price)
    },
    setHouseStyle (payload) {
      this.$store.commit('setFilterStyle', payload)
    },
    setHouseType (payload) {
      this.$store.commit('setFilterType', payload)
    }
  }
}
</script>
